<div class="quick-search-window-section">
  <div class="quick-search-window">
    <div class="quick-search-input-section">
      <app-svg-icons
        icons="search"
        width="20"
        height="20"
        color="grey" />
      <input
        #searchInput
        class="quick-search-input"
        type="text"
        name="search"
        placeholder="Search (e.g., '1008', 'John Doe', etc)"
        [value]="payload()?.search || ''"
        (input)="onChange($event)" />
    </div>
    <div class="quick-search-checkbox-section">
      <app-checkbox
        title="Load"
        name="LOAD"
        [selected]="payload()?.search_for?.includes('LOAD')"
        (handleCheck)="handleChange($event)" />
      <app-checkbox
        title="Truck"
        name="TRUCK"
        [selected]="payload()?.search_for?.includes('TRUCK')"
        (handleCheck)="handleChange($event)" />
      <app-checkbox
        title="Trailer"
        name="TRAILER"
        [selected]="payload()?.search_for?.includes('TRAILER')"
        (handleCheck)="handleChange($event)" />
      <app-checkbox
        title="Driver"
        name="DRIVER"
        [selected]="payload()?.search_for?.includes('DRIVER')"
        (handleCheck)="handleChange($event)" />
      <app-checkbox
        title="Customer"
        name="CUSTOMER"
        [selected]="payload()?.search_for?.includes('CUSTOMER')"
        (handleCheck)="handleChange($event)" />
    </div>
    <div class="quick-search-result-section">
      <div class="quick-search-results">
        <div class="quick-search-result-card">
          @if (combinedData()?.list?.length > 0) {
            @if (searchData()?.load?.length > 0) {
              <div class="quick-search-result-type-card"
                >
                <h4>Loads</h4>
                <hr />
                @for (item of searchData()?.load || []; track item.id ?? item) {
                  <app-short-detail-card
                [list]="{
                icon: 'truck-loaded',
                name: item?.customer_reference_number,
                value: item?.cuid,
                url: '#/dispatch/loads/running-v2/activeList-2?currentLoad='+item?.id}" />
}
            </div>
}
            @if (searchData()?.truck?.length > 0) {
<div class="quick-search-result-type-card"
             >
              <h4>Trucks</h4>
              <hr />
              @for (item of searchData()?.truck || []; track item.id ?? item) {
<app-short-detail-card
               
                [list]="{
                icon: 'truck-body',
                name: item?.number,
                value: item?.id_status,
                url: '#/assets/truck?id='+item?.id+'&tab=overview&type=details'
                }" />
                }
              </div>
            }
            @if (searchData()?.trailer?.length > 0) {
              <div class="quick-search-result-type-card"
                >
                <h4>Trailers</h4>
                <hr />
                @for (item of searchData()?.trailer || []; track item.id ?? item) {
                  <app-short-detail-card
                [list]="{
                icon: 'trailer-fancy',
                name: item?.number,
                value: item?.id_status,
                url: '#/assets/trailer?id='+item?.id+'&tab=overview&type=details'
                }" />
                }
              </div>
            }
            @if (searchData()?.driver?.length > 0) {
              <div class="quick-search-result-type-card"
                >
                <h4>Drivers</h4>
                <hr />
                @for (item of searchData()?.driver || []; track item.id ?? item) {
                  <app-short-detail-card
                [list]="{
                icon: 'driver-person',
                name: item?.name,
                value: item?.id_status,
                url: '#/assets/driver?id='+item?.id+'&tab=personal-info&type=details'
                }" />
                }
              </div>
            }
            @if (searchData()?.customer?.length > 0) {
              <div class="quick-search-result-type-card"
                >
                <h4>Customer</h4>
                <hr />
                @for (item of searchData()?.customer || []; track item.id ?? item) {
                  <app-short-detail-card
                [list]="{
                icon: 'buildings',
                name: item?.name,
                value: item?.fmcsa_status,
                url: '#/customer?id='+item?.id+'&tab=overview'
                }" />
                }
              </div>
            }
          } @else {
            <div class="no-data-found">
              <div class="no-data-icon-section">
                <div class="no-data-icon">
                  @if (payload()?.search?.length == 0) {
                    <app-svg-icons
                      icons="search" />
                  }
                  @if (payload()?.search?.length > 0) {
                    <app-svg-icons
                      icons="empty-folder" />
                  }
                </div>
              </div>
              @if (payload()?.search?.length == 0) {
                <div class="no-data-message"
                  >
                  <p>Your Quick Search Hub</p>
                  <span>Looking for loads, trucks, trailers, drivers or
                    customers?
                    Simply enter your terms and Get precise matches instantly
                    and
                  keep your operations moving.</span>
                </div>
              }
              @if (payload()?.search?.length>0) {
                <div class="no-data-message"
                  >
                  <p>No Matches Found</p>
                  <span>We couldn’t find any loads, trucks, trailers, drivers,
                    or
                    customers that match your search. Try different keywords or
                  check your spelling.</span>
                </div>
              }
            </div>
          }

        </div>
      </div>
    </div>

    <div class="quick-search-close-button-section">
      <button
        class="quick-search-close-button"
      (click)="handleClose()">x</button>
    </div>
  </div>
</div>
